import type { RouteObject } from "react-router";
import { WebhookLogList } from "./webhook-log-list/WebhookLogList";

export const webhookLogRoute: RouteObject = {
  path: "webhook-log",
  element: <WebhookLogList />,
};
